import { Moment } from 'moment';

export enum DateTimeFormats {
  // 14/02/2025
  Date = 'DD/MM/YYYY',
  // Sep 21
  Date1 = 'MMM D',
  // 14 Feb 2025
  Date2 = 'DD MMM YYYY',
  // 16 November
  Date3 = 'DD MMMM',
  // November 2025
  Date4 = 'MMMM YYYY',
  // December 02, 2024
  Date5 = 'MMMM DD, YYYY',
  // 02 December 2024
  Date6 = 'DD MMMM YYYY',
  // 2024
  Date7 = 'YYYY',
  // 25 September 2025, Wednesday
  Date8 = 'dd MMMM yyyy, EEEE',
  // 2024 02
  Date9 = 'YYYY MM',
  // 2024-02-14
  DateISO = 'YYYY-MM-DD',
  // 14/02/2025 - 08:00
  DateTime = 'DD/MM/YYYY - HH:mm',
  // 2024-02-14T08:00:00
  DateTimeISO = 'YYYY-MM-DDTHH:mm:ss',

  // 02 December 2024 - 08:00
  DateTime1 = 'DD MMMM YYYY - HH:mm',
  // 2025-07-18T05:00
  DateTime2 = 'YYYY-MM-DDTHH:mm',
  // 02 December 2024 - 08:00
  DateTime3 = 'DD MMMM YYYY, dddd',
  // 14/02/2025 08:00
  DateTime4 = 'DD/MM/YYYY HH:mm',
  // 8:16 AM
  Time = 'h:mm\u00A0A',
  // 13:30
  Time1 = 'HH:mm',
  // 01/04 11:00
  DateTimeShort = 'DD/MM HH:mm',
  // 08:16 am
  Time2 = 'HH:mm\u00A0a',
  // 8:16 am
  Time3 = 'H:mm\u00A0a',
  // 08:16  AM
  Time4 = 'HH:mm\u00A0 A',
  // Sun-Sat
  Day = 'ddd',
  // Sunday-Saturday
  Day2 = 'dddd'
}

export type TimeSpan = {
  hours: number;
  minutes: number;
  seconds: number;
};

export interface BankHolidayEvent {
  title: string;
  date: string;
  notes: string;
  bunting: boolean;
}

export interface RegionBankHolidays {
  division: string;
  events: BankHolidayEvent[];
}

export interface BankHolidaysResponse {
  [region: string]: RegionBankHolidays;
}

export interface DayData {
  id: number;
  date: Moment;
  dayOfWeek: string;
  dayNumber: number;
  isWeekend: boolean;
  isBankHoliday: boolean;
}
